module.exports = __webpack_public_path__ + "img/pimg4.44008d08.png";